import { Controller } from "stimulus";

// Save stays disabled until the pick differs from the value on file, so a
// click can never post a no-op. The form is remote; the response swaps the
// control in place.
export default class extends Controller {
  static targets = ["select", "save"];

  connect() {
    this.initial = this.selectTarget.value;
  }

  dirty() {
    this.saveTarget.disabled = this.selectTarget.value === this.initial;
  }
}
